import { Link, graphql } from 'gatsby'
import { ComponentPropsWithoutRef } from 'react'

interface Props extends ComponentPropsWithoutRef<'a'> {
  data: Queries.PageLinkFragment | null
}

const PageLink = ({ data, ...props }: Props): JSX.Element => {
  return (
    <Link
      to={`/${data?.page?.slug}${data?.page?.slug ? '/' : ''}`}
      {...props}
    >
      <span>{data?.linkText}</span>
    </Link>
  )
}

export const PageLinkFragment = graphql`
  fragment PageLink on DatoCmsPageLink {
    id: originalId
    __typename
    linkText
    page {
      ... on DatoCmsHome {
        id: originalId
        slug
      }
      ... on DatoCmsPage {
        id: originalId
        slug
      }
      ... on DatoCmsNewsPage {
        id: originalId
        slug
      }
    }
  }
`

export default PageLink
